import { render } from "./TheHotels.vue?vue&type=template&id=dcf32544&scoped=true"
import script from "./TheHotels.vue?vue&type=script&lang=js"
export * from "./TheHotels.vue?vue&type=script&lang=js"

import "./TheHotels.vue?vue&type=style&index=0&id=dcf32544&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf32544"]])

export default __exports__